import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="bg-black text-white">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <b className="purple fw-bold">Rohan Singh </b>
            <br /> I am a final year student pursuing B.Tech
            in Computer Science and Engineering from Vellore Institue of Technology, Bhopal.
            <br />
            Additionally, I am currently working as an Interns Web developer at
            Algozenith
            <br />
            <br />
          </p>

          
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
